'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _bluebird = require('bluebird');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_bluebird.Promise.config({
  cancellation: true
});

var methods = ['get', 'post', 'put', 'patch', 'del'];

function formatUrl(path) {
  var adjustedPath = path[0] !== '/' ? '/' + path : path;
  if (__SERVER__) {
    // Prepend host and port of the API server to the path.
    return 'http://localhost:' + _config2.default.port + '/api' + adjustedPath;
  }
  // Prepend `/api` to relative URL, to proxy to API server.
  return '/api' + adjustedPath;
}

/*
 * This silly underscore is here to avoid a mysterious "ReferenceError: ApiClient is not defined" error.
 * See Issue #14. https://github.com/erikras/react-redux-universal-hot-example/issues/14
 *
 * Remove it at your own risk.
 */

var _ApiClient = function _ApiClient(req) {
  var _this = this;

  (0, _classCallCheck3.default)(this, _ApiClient);

  methods.forEach(function (method) {
    return _this[method] = function (path) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          params = _ref.params,
          data = _ref.data;

      return new _bluebird.Promise(function (resolve, reject, onCancel) {
        var request = _superagent2.default[method](formatUrl(path));

        if (params) request.query(params);

        if (__SERVER__ && req.get('cookie')) {
          request.set('cookie', req.get('cookie'));
        }

        if (data) request.send(data);

        request.end(function (err) {
          var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              body = _ref2.body;

          return err ? reject(body || err) : resolve(body);
        });

        onCancel(function () {
          request.abort();
        });

        return request;
      });
    };
  });
};

var ApiClient = _ApiClient;

exports.default = ApiClient;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/ApiClient.js
// module id = 1192
// module chunks = 0